/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-20T20:38:25.851
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listDroomConEstateInfo,
	listDroomConEstateInfoInit,
	listDroomConEstateInfoByAuthorizations,
	deleteDroomConEstateInfo
} from '@api/storagemanage/DroomConEstateInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listDroomConEstateInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDroomConEstateInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listDroomConEstateInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDroomConEstateInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listDroomConEstateInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listDroomConEstateInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteDroomConEstateInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteDroomConEstateInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
